import s from './Title.module.css'

type Props = {
  children: React.ReactNode
}

export const Title = ({ children }: Props) => {
  return <h1 className={s.title}>{children}</h1>
}
